// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".schedule-label[data-v-536ad02a] {\n  margin-bottom: 0.5rem;\n}\n@media (max-width: 576px) {\n.schedule-label[data-v-536ad02a] {\n    margin-bottom: 0.25rem;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
